module.exports = __webpack_public_path__ + "033e6cf0dce65ff8894106636423b067.png";